import { render, staticRenderFns } from "./excel-download-purchase-order-status-regular.vue?vue&type=template&id=028e5780&"
import script from "./excel-download-purchase-order-status-regular.vue?vue&type=script&lang=js&"
export * from "./excel-download-purchase-order-status-regular.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports